module.exports = require("react-responsive");


//////////////////
// WEBPACK FOOTER
// external "react-responsive"
// module id = 19
// module chunks = 0